import React from 'react';

class EditUserHeaderPage extends waffle.base.BaseComponent {
  constructor(props) {
    super(props);
  };

  componentWillMount() {
  };

  clearIdNumber() {
    radio('showLoader').broadcast();
    usersApi(`${this.props.uuid}/clearIdNumber`).done((response) => {
      if (response.status === 200) {
        radio('showAlert').broadcast('success', 'ID number cleared');
        window.location.reload();
      } else {
        radio('showAlert').broadcast('danger', `${response.message} (${response.status})`);
      }
    }).fail((_, textStatus) => {
      radio('hideLoader').broadcast();
      radio('showAlert').broadcast('danger', textStatus);
    });
  };

  clearPassportNumber() {
    radio('showLoader').broadcast();
    usersApi(`${this.props.uuid}/clearPassportNumber`).done((response) => {
      if (response.status === 200) {
        radio('showAlert').broadcast('success', 'Passport number cleared');
        window.location.reload();
      } else {
        radio('showAlert').broadcast('danger', `${response.message} (${response.status})`);
      }
    }).fail((_, textStatus) => {
      radio('hideLoader').broadcast();
      radio('showAlert').broadcast('danger', textStatus);
    });
  };

  render() {
    return (
        <div className='editUserMainContainer'>
          <header className='editUserHeader' >
            <h1>
              User
            </h1>
            {this.props.has_yoco_vetting_role ? this.getHeaderButtons() : ''}
          </header>
        </div>
    );
  };

  getHeaderButtons() {
    return(
      <div className='editUserHeaderButtons'>
        <HeaderButton
            buttonText="Clear ID number"
            buttonType="btn-danger editUserHeaderButton"
            onPress={() => this.clearIdNumber()}
        />
        <HeaderButton
            buttonText="Clear passport number"
            buttonType="btn-danger editUserHeaderButton"
            onPress={() => this.clearPassportNumber()}
        />
      </div>
    );
  };
}

function usersApi(urlSuffix){
  return $.ajax({
    url: `/api/users/${urlSuffix}`,
    method: 'POST',
  });
}

const HeaderButton = ({buttonText,buttonType,onPress}) => (
    <button
        type="button"
        className={buttonType}
        onClick={onPress}
    >
      {buttonText}
    </button>
);

module.exports = {
  EditUserHeaderPage
};
